import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";



interface Iprops {
    req_id: number,
    open: boolean,
    hideDialog: () => void,
    toast: any,
}

interface IReq_Query {
    req_ID: number,
    comment?: string,
    user_Name?: string,
    queryTime?: Date
}

export const ReqQuery = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IReq_Query>, loading: boolean });
    const [comment, setComment] = useState("");

    useEffect(() => {
        if (props.req_id && props.open) {
            loadData();
        }
    }, [props.open]);

    const loadData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Requirement_MAST/query", "GET", null, `req_id=${props.req_id}`, props.toast);
        if (response) {
            const data: IReq_Query[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const saveToDB = async () => {
        if (comment.length >= 10) {
            setTableData({ tableData: tableData.tableData, loading: true });
            const body: IReq_Query = {
                req_ID: props.req_id,
                comment: comment
            }
            const response = await Fetch("Requirement_MAST/query", "POST", body, null, props.toast);
            if (response) {
                setComment("");
                const response2 = await Fetch("Requirement_MAST/query", "GET", null, `req_id=${props.req_id}`, props.toast);
                if (response2) {
                    const data: IReq_Query[] = await response2.json();
                    setTableData({ tableData: data, loading: false });
                } else setTableData({ tableData: tableData.tableData, loading: false });
            } else setTableData({ tableData: tableData.tableData, loading: false });
        } else props.toast.current.show({ severity: 'error', detail: "Query should be atleast 10 characters long.", life: 3000 });
    }

    const queryTime = (rowData: IReq_Query) => {
        let date;
        if (rowData.queryTime) date = format(new Date(rowData.queryTime), 'dd/MM/yyyy hh:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const onHide = () => {
        props.hideDialog();
        setComment("");
        setTableData({ tableData: [], loading: false });
    }
    const loginObj: ILogin= JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={<span>Query for Requirement ID - {props.req_id}</span>} className="p-fluid" onHide={onHide} maximizable>
            <div className="p-fluid formgrid grid m-1 mb-3">
                <label htmlFor="query">Query :</label>
                <InputTextarea name="query" placeholder="write your query here..." value={comment} onChange={(e) => setComment(e.target.value)} rows={5} cols={30} maxLength={500} autoResize />
                <Button loading={tableData.loading} className="p-button-sm my-1" label="OK" onClick={saveToDB} type="button" />
            </div>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" value={tableData.tableData} loading={tableData.loading}
            >
                <Column field="user_Name" header="Name" headerStyle={{ width: '10%' }} />
                {/* <Column field="queryTime" header="Time" body={queryTime} headerStyle={{ width: '10%' }} /> */}
                   <Column field="queryTime" header="Time" body={(rowData: any) => safeFormatDate(rowData.queryTime, 'dd/MM/yyyy', DateFormat, true)} headerStyle={{ width: '10%' }} />
                <Column field="comment" header="Comment" headerStyle={{ width: '90%' }} />
            </DataTable>
        </Dialog>
    );
}